import { styled, Button, DialogContent, Grid, Theme, makeStyles, createStyles } from '@material-ui/core';
// import { StyledDialog } from '@room-match/shared-ui-components';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
import { COLORS } from 'shared/constants/COLORS';

export const CloseButton = styled(Button)({
  position: 'absolute',
  top: '20px',
  right: '20px',
  cursor: 'pointer',
  minWidth: 'unset',
  borderRadius: '100%',
  width: 30,
  height: 30,
  background: 'none',
});

export const CustomDialog = styled(StyledDialog)<Theme, { type: string }>(({ type = 'contact' }) => ({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '485px !important',
    // minHeight: type === 'contact' ? 800 : 720,
  },
}));

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: '40px 70px 50px!important',
  background: theme.palette.type === 'dark' ? '#0d1117' : COLORS.WHITE,
  display: 'flex',
  flexDirection: 'column',
  height: 'fit-content',

  [theme.breakpoints.down('xs')]: {
    padding: '40px 25px 50px!important',
  },
}));

export const Header = styled('div')({
  marginBottom: 30,
  textAlign: 'center',
});

export const Content = styled(Grid)({
  '& > div:not(:last-child)': {
    marginBottom: 10,
  },

  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    // background: '#0e1319',
    background: 'transparent',
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: '#c2ccd8',

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },

  '& input::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },

  '& input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
});

export const ActionsContainer = styled('div')(({ theme }) => ({
  marginTop: 35,
  display: 'flex',
  gap: 15,
}));

export const CustomButton = styled(Button)<Theme, { isEdit?: boolean }>(({ isEdit }) => ({
  borderRadius: 5,
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  height: 44,
  fontSize: 16,
  '&:disabled': {
    color: COLORS.WHITE,
    opacity: 0.4,
  },
}));

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    textInputStyle: {
      backgroundColor: (theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE) + ' !important',
    },
    select: {
      backgroundColor: 'transparent !important',
      '& .MuiSelect-icon': {
        color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
        top: 15,
        right: 12,
      },
    },
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
    },
    popUpIndicator: {
      color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
    },
    workingLocationSelect: {
      backgroundColor: 'transparent !important',
      marginTop: 10,
      '& .MuiSelect-icon': {
        color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
        top: 15,
        right: 12,
      },
    },
  }),
);
